// Port of api/fuel/app/classes/filter/search/games/rules/query/games.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'games',
	isIndex: function() { return 'game' }
})
